// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2-5n4","colCheckbox":"styles_colCheckbox__1_dli"};